import React from 'react';
import { SEO } from './SEO';
import '../styles/privacy.css';

export const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <SEO 
        title="Privacy Policy"
        description="Privacy policy for POE2 Skills AI. Learn about how we collect, use, and protect your data while using our services."
        canonicalUrl="https://www.poe2skills-ai.com/privacy"
        noindex={true}
      />
      <div className="privacy-container">
        <h1>Privacy Policy</h1>
        <div className="privacy-content">
          <section>
            <h2>1. Information We Collect</h2>
            <p>We collect minimal information to provide our AI PoE2 Skills Planner service. This includes:</p>
            <ul>
              <li>Chat interactions with our AI system</li>
              <li>Number of chats used per session</li>
            </ul>
          </section>

          <section>
            <h2>2. How We Use Your Information</h2>
            <p>The information collected is used solely to:</p>
            <ul>
              <li>Provide build recommendations and game advice</li>
              <li>Improve our AI responses</li>
              <li>Track chat usage limits</li>
            </ul>
          </section>

          <section>
            <h2>3. Data Storage</h2>
            <p>We use local storage to track chat limits. No personal data is stored on our servers.</p>
          </section>

          <section>
            <h2>4. Third-Party Services</h2>
            <p>We use DeepSeek AI for processing chat responses. Please refer to DeepSeek's privacy policy for information about their data handling practices.</p>
          </section>

          <section>
            <h2>5. Contact</h2>
            <p>For privacy-related questions, please contact us at [Your Contact Information].</p>
          </section>
        </div>
      </div>
    </>
  );
};